import type { DataClientOptions } from "./index";

export const getDefaultDataClientOptions = (): DataClientOptions => ({
    connectToDevTools: false
});
